import { FormattedMessage, useIntl } from 'react-intl'
import Info from 'components/shared/Info'
import Box from 'components/shared/Box'
import Link from 'components/shared/Link'
import Button from 'components/shared/Button'
import Price from 'components/shared/Price'
import { CityBreakFooterContainer } from './CityBreakFooter.styles'
import { CityBreakFooterProps } from './CityBreakFooter.types'
import useCityBreak from 'components/common/CityBreak/utils/useCityBreak'
import { useCityCart } from 'components/common/CityBreak/utils/useCityCart'
import { useEffect } from 'react'
import { useResolutions } from 'store/resolutions'
import { GenericTechnicalError } from 'components/global/GenericTechnicalError'

export const CityBreakFooter = ({
    hasBlockingError,
    onSubmitSuccess,
    onCancel,
}: CityBreakFooterProps) => {
    const { formatMessage } = useIntl()
    const { isTablet } = useResolutions()
    const { totalPrice, isCityBreakApplicableForAccommo } = useCityBreak()
    const { addItemsToCart, isSubmitLoading, isSubmitSuccess, isSubmitError } =
        useCityCart()

    const handleSubmit = () => {
        if (isCityBreakApplicableForAccommo)
            onSubmitSuccess && onSubmitSuccess()
        else addItemsToCart()
    }

    useEffect(() => {
        if (isSubmitSuccess && onSubmitSuccess) onSubmitSuccess()
    }, [isSubmitSuccess])

    return (
        <CityBreakFooterContainer gap={[24, 32]}>
            {/* no refunds info */}
            {(!isCityBreakApplicableForAccommo || isTablet) &&
                !hasBlockingError && (
                    <Info color="info" align={['center', 'flex-start']}>
                        <FormattedMessage
                            id="promo.city_break.no_refunds_msg"
                            defaultMessage="_"
                        />
                    </Info>
                )}
            {/* error info */}
            {isSubmitError && <GenericTechnicalError />}

            <Box
                direction={['column', 'row']}
                justify="space-between"
                align={['flex-end', 'center']}
                gap={12}
                isFullWidth
            >
                <Box
                    direction="row"
                    align="baseline"
                    justify={['flex-end', 'flex-start']}
                >
                    <Price
                        value={totalPrice}
                        size="heading2"
                        currencySize="bodyStrong"
                        description={formatMessage({
                            id: 'global.price.label_total_colon',
                            defaultMessage: '_',
                        })}
                        descriptionSize="bodySmall"
                    />
                </Box>
                <Box direction="row" gap={24} align="center">
                    <Link
                        variant="gray"
                        icon={null}
                        onClick={onCancel}
                        data-testid="city-button-cancel"
                        isDisabled={isSubmitLoading}
                    >
                        <FormattedMessage
                            id="global.btn.cancel"
                            defaultMessage="Anuluj"
                        />
                    </Link>
                    <Button
                        variant="secondary"
                        width="initial"
                        data-testid="city-button-add"
                        onClick={handleSubmit}
                        isLoading={isSubmitLoading}
                        isDisabled={isSubmitError || hasBlockingError}
                    >
                        <FormattedMessage
                            id="global.btn.add"
                            defaultMessage="_"
                        />
                    </Button>
                </Box>
            </Box>

            {/* no refunds info */}
            {isCityBreakApplicableForAccommo && !isTablet && !hasBlockingError && (
                <Info color="info" align={['center', 'flex-start']}>
                    <FormattedMessage
                        id="promo.city_break.no_refunds_msg"
                        defaultMessage="_"
                    />
                </Info>
            )}
        </CityBreakFooterContainer>
    )
}
